module.exports = __webpack_public_path__ + "static/media/公路局VR宣传视频.9155f13.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/公路局VR宣传视频.mp4
// module id = 9iwS
// module chunks = 12